"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDates = void 0;
const moment_1 = __importDefault(require("moment")); // Import Moment.js
function validateDates(endDate, minDaysBefore) {
    if (!moment_1.default.isMoment(endDate)) {
        throw new Error("Invalid end date. Please provide a valid moment object.");
    }
    if (!Number.isInteger(minDaysBefore) || minDaysBefore < 0) {
        throw new Error("Invalid minimum days before. Please provide a positive integer.");
    }
    const currentDate = (0, moment_1.default)();
    const minStartDate = (0, moment_1.default)(endDate).add(minDaysBefore, 'days');
    // Check if end date is after current date (inclusive)
    if (!endDate.isSameOrBefore(currentDate)) {
        throw new Error("End date cannot be after current date.");
    }
    // Check if minimum start date is before current date (exclusive)
    if (minStartDate.isAfter(currentDate)) {
        throw new Error(`Minimum start date cannot be after current date.`);
    }
    return {
        isValid: true,
        minStartDate: minStartDate
    };
}
exports.validateDates = validateDates;
